import { PageIntro } from "@/components/site/PageIntro";
import { Placeholder } from "@/components/site/Placeholder";
import { EngageBand } from "@/components/site/EngageBand";
import { Container, Mono, TextLink } from "@/components/site/primitives";
import { SoftwareExplorer } from "@/components/explorers/SoftwareExplorer";

const Notes = () => (
  <section className="border-b border-o-line" data-testid="software-notes">
    <Container className="grid gap-4 pb-16 md:grid-cols-2 lg:pb-24">
      <div className="border border-o-line bg-o-surface p-6 sm:p-8">
        <Mono accent>Two ways in</Mono>
        <p className="mt-3 leading-relaxed">Through Ordo Diagnostic, when the problem comes first. Or directly, when an organization already knows which capability it needs.</p>
        <TextLink to="/enterprise/diagnostic" testid="software-diagnostic-link" className="mt-5">Ordo Diagnostic</TextLink>
      </div>
      <div className="border border-dashed border-o-strong p-6 sm:p-8" data-testid="software-not-inventory">
        <Mono>Not in this inventory</Mono>
        <p className="mt-3 leading-relaxed text-o-dim">General Ordo Infrastructure is a separate licensing route for organizations building their own intelligent systems, not a fifth applied capability.</p>
        <TextLink to="/ordo/infrastructure" testid="software-infra-link" className="mt-5">General Ordo Infrastructure</TextLink>
      </div>
    </Container>
  </section>
);

export default function SoftwarePage() {
  return (
    <>
      <PageIntro routeKey="software" group="enterprise" index="AS" eyebrow="Applied software · One coherent view"
        title="Four applied capabilities, each with its own responsibility."
        lede="Ordo Engine and Ordo Stewardship form the Ordo software family. Breakpoint and Mesh are separate offerings that install independently. Organizations adopt what their situation calls for; none of the four requires the others."
        aside={<Placeholder label="Applied software family relationship" note="The four capabilities and how they group" ratio="4 / 3" testid="placeholder-software" />} />
      <section data-testid="software-explorer-section">
        <Container className="py-16 lg:py-20">
          <SoftwareExplorer />
        </Container>
      </section>
      <Notes />
      <EngageBand path="business" from="/enterprise/software" title="Ask about a capability."
        text="Start a business inquiry about one capability, or several. During Phase 1 this inquiry is an inactive preview." />
    </>
  );
}
